import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  ServerInstrumentationTooltip,
  ServerInstrumentationTooltipProps
} from '../../../components/servers-grid/server-instrumentation-tooltip'

function ServerInstrumentationTooltipBridge({
  serverName,
  placement,
  size
}: ServerInstrumentationTooltipProps) {
  return (
    <ServerInstrumentationTooltip
      serverName={serverName || ''}
      placement={placement}
      size={size}
      e2eTestId="server-instrumentation-tooltip"
    />
  )
}

export const reactServerInstrumentationTooltip = createNgReactBridgeDirective(
  'reactServerInstrumentationTooltip',
  [],
  ServerInstrumentationTooltipBridge,
  ['serverName', 'placement', 'size']
)
